import {
  getPage
} from '@/plugins/PlatformSup.js';
export default {
  data() {
    return {
      pageRoute: "insBaseField",
      tagslist: [{
          name: "基本資料",
          pagename: "insBaseField"
        },
        {
          name: "消費相關",
          pagename: "insCost"
        },
        {
          name: "規格方案",
          pagename: "insSpecification"
        },
        {
          name: "庫存管理",
          pagename: "insStock"
        },
        {
          name: "文宣／收據",
          pagename: "insOther"
        }
      ],
      productdata: {
        method: "insert",
        insBaseField: {
          uid: 'T_PRO___' + Math.random() * 100000000,
          Class1: "",
          Class2: "",
          inClass: "",
          price: {
            base: 0,
            sell: 900,
            cost: 0
          },
          element: [],
          name: "",
          smallname: "",
          version: "",
          code: "",
          sela: "0",
          hit: "0",
          online: "0",
          order: {
            method: "custom",
            order: 1
          },
          limitnumber: null
        },
        insCost: {
          showoff: 0,
          buyfulloff: {
            check: 0,
            number: null,
            method: "off",
            offmoney: null,
          },
          aginoffrule: [],
          setAddClass: {
            Class: "",
            showaddPro: 0
          },
          freightdata: {
            method: [],
            postoffmoney: 900,
            conveniencemoney: null,
            settingmoney: null
          },
          freightset: {
            doublemoney: 1,
            doublelimit: null,
            buyfullnofre: 1,
            buyfullnumber: null,
            selectset: 0,
            selectsetfreighmonth: "",
            selectsetfreighday: "",
            selectsetfreighmethod: "",
            selectsetfreighname: "",
            noUseWeb: 0
          },
          reminder: "",
          paydata: {
            method: [],
            transfermoney: null,
            delivery: null
          },
          period: [{
            code: "CCCC",
            pre: "OOP",
            name: "優惠第一波00",
            startdate: "2020/03/20",
            enddate: "2020/05/20",
            remark: '',
            order: "",
            online: "1",
            delete: 0,
            price: {
              method: "dispa",
              price: 20
            }
          }]
        },
        insSpecification: {
          method: "multiple", //single  /multiple /case
          synele: 0,
          speCheck: 0,
          maxnumber: {
            method: "",
            number: null
          },
          single: {
            pro: []
          },
          multiple: {
            case1: [],
            case2: []
          },
          casemethod: [{
            name: "hello",
            element: [],
            period: [],
            price: {
              base: 0,
              sell: 0,
              cost: 0
            }
          }],
        },
        insStock: {
          product: {
            inventory: null, //庫存量
            inventorymethod:null,
            stopselling: {
              check: 0,
              number: null
            },
            showinventory: {
              show:0,
              setshownumber:null
            },
            showonlinedate: 0,
          },
          spec: {
            
          }
        },
        insOther: {}
      }
    }
  },
  methods: {
    changeTagsPage(name) {
      this.pageRoute = name;
    },
    backPage() {
      this.$router.go(-1);
    },
    savePro() {
      console.log(this.productdata);
    }

  }, 
  computed: {
    imporpage() {
      console.log("page:" + this.pageRoute);
      return getPage(this.pageRoute, "components/InsertProduct");
    }
  }
};
